// src/components/Card.js
import React from 'react';

const VideoCard = ({ imageSrc, title, duration, videoUrl }) => {
  return (
    <a href={videoUrl} target="_blank" rel="noopener noreferrer" className="block p-4 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
      <div className="relative">
        <img src={imageSrc} alt={title} className="w-full h-70 object-cover rounded-md" />
        <div className="absolute bottom-2 right-2 bg-red-600 text-white p-2 rounded-full flex items-center justify-center shadow-lg">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
          </svg>
        </div>
      </div>
      <h2 className="mt-2 text-lg font-semibold">{title}</h2>
      <p className="mt-1 text-gray-600">{duration}</p>
    </a>
  );
};

export default VideoCard;